import { render } from "./Player.vue?vue&type=template&id=12ef87a4&scoped=true&ts=true"
import script from "./Player.vue?vue&type=script&lang=ts"
export * from "./Player.vue?vue&type=script&lang=ts"

import "./Player.vue?vue&type=style&index=0&id=12ef87a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ef87a4"]])

export default __exports__